<template>
  <div class="patient-list">
    <header class="patient-list-header">
      <h2 class="title">请选择家庭成员</h2>
      <div class="add-btn" @click="addRecord">
        <img class="img-add" alt="" src="@/assets/images/add-member-btn.png" />
        <span>添加家人</span>
      </div>
    </header>
    <template v-if="userSignList.length">
      <div class="patient-list-ul">
        <div
          v-for="(item, index) in userSignList"
          :key="index"
          class="patient-list-li"
          @click="selectPatient(item.userMsg.profileId, item.userSignInfo)"
        >
          <span class="tag">保障中</span>
          <div class="patient-list-li-lt">
            <div class="personal-info">
              <img class="img-avatar" :src="item.userMsg.gender === 1 ? avatarMale : avatarFemale" alt="" />
              <div class="personal-info-right">
                <div class="name-tag">
                  <div class="name">{{ item.userMsg.fullName }}</div>
                  <div class="relation-tag">{{ configStore.dict?.userRelation[item.userMsg.relation] }}</div>
                </div>
                <div class="age-sex">{{ item.userMsg.gender === 1 ? '男' : '女' }} · {{ item.userMsg.age }}岁</div>
              </div>
            </div>
            <div class="id-info">
              <span class="line"></span>
              <div class="id-type">
                {{ configStore.dict?.certType[item.userMsg.certType] }}
              </div>
              <div class="id-info-content">{{ item.userMsg.certNo }}</div>
            </div>
          </div>
          <div class="rt-select" :class="{ select: currentProfileId === item.userMsg.profileId }">
            <div v-if="currentProfileId === item.userMsg.profileId" class="select-circle"></div>
          </div>
        </div>
      </div>
      <div class="patient-list-bottom">
        <div class="wrap-btn">
          <wx-open-launch-weapp v-if="currentProfileId" class="btn selected" :appid="appid" :path="jumpPath">
            <component :is="'script'" type="text/wxtag-template">
              <div style="color: #fff; font-weight: 500; display: flex; align-items: center; justify-content: center">
                确定
              </div>
            </component>
          </wx-open-launch-weapp>
          <div v-else class="btn unselect">确定</div>
        </div>
      </div>
    </template>
    <div v-else class="empty-box">
      <img class="img-empty" src="@/assets/images/empty.png" alt="" />
      <div class="empty-word">暂无建档信息</div>
      <div class="empty-sub-word">请点击【添加家人】进行建档</div>
      <div class="add-member-btn" @click="addRecord">添加家人</div>
    </div>
  </div>
</template>

<script lang="ts">
import { router } from '@/router';
import { useUserStore } from '@/store/modules/user';
import avatarFemale from '@/assets/images/avatar-female.png';
import avatarMale from '@/assets/images/avatar-male.png';
import { useConfigStore } from '@/store/modules/config';
import { computed } from 'vue';
import { useRouter } from 'vue-router';
export default {
  setup() {
    const userStore = useUserStore();
    const configStore = useConfigStore();
    const { currentRoute } = useRouter();

    const addRecord = () => {
      router.push({ name: 'records-guide' });
    };

    const userSignList = ref([]);
    const currentProfileId = ref('');
    const queryList = async () => {
      const { signItem = [] } = await userStore.signList({ pageType: 5 });
      userSignList.value = signItem || [];
    };

    queryList();

    const hospitalId = ref('');
    const selectPatient = (profileId: string, userSignInfo) => {
      currentProfileId.value = profileId;
      const { fullCycleId = '' } = userSignInfo.find((item) => item.profileId === currentProfileId.value);
      hospitalId.value = fullCycleId;
    };

    const jumpPath = computed(() => {
      const { origin } = currentRoute.value?.query;
      const pathObj = {
        followUp: '/pages/intelligentFollowUp/index',
        afterDiagnosisPlan: '/pages/intelligentFollowUp/afterDiagnosisPlan',
      };
      return `pages/entry/index?safePatientId=${currentProfileId.value}&moduleName=${origin}&hospitalId=${hospitalId.value}&path=${pathObj[origin]}`;
    });

    return {
      userSignList,
      addRecord,
      avatarFemale,
      avatarMale,
      configStore,
      selectPatient,
      currentProfileId,
      appid: import.meta.env.VITE_FULL_CYCLE_APPID,
      jumpPath,
    };
  },
};
</script>

<style scoped lang="less">
.patient-list {
  width: 100%;
  position: relative;
  background: #fff;
  min-height: calc(100vh - env(safe-area-inset-bottom));
  display: flex;
  flex-direction: column;
  &-header {
    width: 100%;
    box-sizing: border-box;
    padding: 32px;
    display: flex;
    justify-content: space-between;
    .title {
      font-weight: 500;
      font-size: 32px;
      line-height: 48px;
      color: #16181a;
    }
    .add-btn {
      width: 204px;
      height: 78px;
      background: #ebf4ff;
      border-radius: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: 600;
      color: #0d7cff;
      .img-add {
        width: 59px;
        height: 59px;
      }
    }
  }
  &-ul {
    width: 100%;
    height: 255px;
    box-sizing: border-box;
    padding: 0 32px;
  }
  &-li {
    width: 100%;
    height: 255px;
    box-sizing: border-box;
    padding: 18px 0 0 24px;
    border: 2px solid #e2eaf4;
    border-radius: 8px;
    position: relative;
    display: flex;
    justify-content: space-between;
    background: linear-gradient(180deg, #d1e9ff 0.3%, #e9f4ff 100%);
    margin-bottom: 20px;
    .tag {
      width: 152px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 24px;
      color: #008cc4;
      position: absolute;
      right: 0;
      top: 0;
      border-radius: 0 8px 0 8px;
      background: linear-gradient(180deg, #99e5fc 0%, #e1f9ff 100%);
    }
    &-lt {
      .personal-info {
        display: flex;
        .img-avatar {
          width: 80px;
          height: 80px;
          margin-right: 24px;
        }
        &-right {
          .name-tag {
            height: 44px;
            display: flex;
            align-items: center;
            .name {
              font-size: 32px;
              font-weight: 500;
              margin-right: 24px;
            }
            .relation-tag {
              width: 82px;
              height: 40px;
              background: rgba(255, 255, 255, 0.4);
              border-radius: 4px;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 22px;
              color: #4e5761;
            }
          }
          .age-sex {
            font-size: 24px;
            line-height: 34px;
            color: #16181a;
            margin-top: 6px;
            font-weight: 500;
          }
        }
      }
      .id-info {
        width: 100%;
        box-sizing: border-box;
        padding: 0 0 0 32px;
        display: flex;
        flex-direction: column;
        margin-top: 32px;
        position: relative;
        .line {
          width: 4px;
          height: 30px;
          background: #0d7cff;
          position: absolute;
          top: 6px;
          left: -2px;
        }
        .id-type {
          height: 42px;
          display: flex;
          align-items: center;
          color: #16181a;
          font-size: 28px;
        }
        &-content {
          height: 42px;
          display: flex;
          align-items: center;
          color: #16181a;
          font-size: 28px;
          font-weight: 500;
          margin-top: 8px;
        }
      }
    }
    .rt-select {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      border: 2px solid #9babbc;
      margin: 62px 32px 0 0;
      display: flex;
      align-items: center;
      justify-content: center;
      &.select {
        border-color: #0d7cff;
      }
      .select-circle {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background: #0d7cff;
      }
    }
  }
  &-bottom {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 2000;
    .wrap-btn {
      width: 100%;
      box-shadow: 18.12px 18.12px 36.23px 0px #151b221a;
      background-color: #fff;
      box-sizing: border-box;
      padding: 24px 24px 56px 24px;
      .btn {
        width: 100%;
        height: 80px;
        color: #fff;
        font-size: 32px;
        font-weight: 500;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
        &.unselect {
          background: #9ecbff;
        }
        &.selected {
          background: #0d7cff;
        }
      }
    }
  }
  .empty-box {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    .img-empty {
      width: 320px;
      height: 220px;
      margin-bottom: 16px;
    }
    .empty-word {
      width: 100%;
      text-align: center;
      font-size: 28px;
      line-height: 42px;
      color: #151b22;
    }
    .empty-sub-word {
      margin-top: 8px;
      width: 100%;
      font-size: 24px;
      text-align: center;
      line-height: 36px;
      color: #9babbc;
    }
    .add-member-btn {
      margin-top: 24px;
      width: 480px;
      height: 80px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px;
      background: #0d7cff;
      font-weight: 500;
      font-size: 32px;
      color: #fff;
    }
  }
}
</style>
